// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"04e06f89","732":"52ca62ac","977":"77b86b59"}[chunkId] + ".chunk.js";
};